const MODAL_TARGET = "back-in-stock-modal";
const KLAVIYO_ENDPOINT = "https://a.klaviyo.com/client/back-in-stock-subscriptions";
const KLAVIYO_REVISION = "2025-01-15";

class BackInStockButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector("[data-bis-button]");
    this.template = this.querySelector("template");

    if (!this.button || !this.template) return;

    this.handleClick = (event) => {
      event.preventDefault();
      this.openModal();
    };

    this.button.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener("click", this.handleClick);
  }

  openModal() {
    const wrapper = document.createElement("div");
    wrapper.innerHTML = this.template.innerHTML.trim();

    const form = wrapper.querySelector("[data-bis-form]");

    if (form) {
      form.dataset.variantId = this.getAttribute("selected-variant") || "";
      form.dataset.companyId = this.getAttribute("company-id") || "";
    }

    this.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: { target: MODAL_TARGET, html: wrapper.innerHTML },
      }),
    );
  }
}

async function subscribe(companyId, variantId, email) {
  const response = await fetch(
    `${KLAVIYO_ENDPOINT}?company_id=${encodeURIComponent(companyId)}`,
    {
      method: "POST",
      headers: {
        revision: KLAVIYO_REVISION,
        "content-type": "application/json",
      },
      body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            channels: ["EMAIL"],
            profile: {
              data: { type: "profile", attributes: { email } },
            },
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      }),
    },
  );

  if (!response.ok) {
    throw new Error(`Klaviyo responded ${response.status}`);
  }
}

document.addEventListener("submit", async (event) => {
  const form = event.target.closest("[data-bis-form]");

  if (!form) return;

  event.preventDefault();

  const emailField = form.querySelector("[data-bis-email]");
  const wrapper = emailField?.closest(".cta-input__input-wrapper");
  const success = form.querySelector("[data-bis-success]");
  const fields = form.querySelector("[data-bis-fields]");
  const email = emailField?.value.trim();

  const setError = (hasError) => {
    wrapper?.classList.toggle("error", hasError);
    emailField?.setAttribute("aria-invalid", hasError ? "true" : "false");
  };

  setError(false);

  if (!email || !emailField.checkValidity()) {
    setError(true);
    emailField?.focus();
    return;
  }

  try {
    await subscribe(form.dataset.companyId, form.dataset.variantId, email);

    if (success) success.hidden = false;
    if (fields) fields.hidden = true;
  } catch (e) {
    setError(true);
  }
});

if (!customElements.get("back-in-stock-button")) {
  customElements.define("back-in-stock-button", BackInStockButton);
}
